let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9fiFD")).then(() => parcelRequire('6SqQk'));